import React from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    icon: {
        width: '44px',
        height: '44px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFFFF',
        fontSize: '20px',
        fontWeight: 600,
        flexShrink: 0
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0px',
        flex: 1
    },
    title: {
        fontSize: '20px',
        fontWeight: 700,
        color: '#1F2152',
        margin: 0
    },
    subtitle: {
        fontSize: '16px',
        fontWeight: 300,
        color: '#5A6A81',
        margin: 0
    }
});

type SuggestionSectionHeaderProps = {
    icon: string;
    title: string;
    subtitle: string;
    iconColor?: string;
};

const SuggestionSectionHeader: React.FC<SuggestionSectionHeaderProps> = ({
    icon,
    title,
    subtitle,
    iconColor = '#FF8A3D'
}) => {
    const classes = useStyles();

    return (
        <div className={classes.header}>
            <div 
                className={classes.icon}
                style={{ backgroundColor: iconColor }}
            >
                <i className={icon} />
            </div>
            <div className={classes.content}>
                <h3 className={classes.title}>{title}</h3>
                <p className={classes.subtitle}>{subtitle}</p>
            </div>
        </div>
    );
};

export default SuggestionSectionHeader;